import React from 'react';

const COLORS = {
  emerald: '#10b981',
  emeraldBg: 'rgba(16,185,129,0.12)',
  amber: '#f59e0b',
  amberBg: 'rgba(245,158,11,0.12)',
};

const EngagementBadge = ({ tag }) => {
  if (!tag) return null;

  const isHighlyEngaged = tag === 'Highly Engaged';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '3px 10px',
        borderRadius: 6,
        fontSize: 11,
        fontWeight: 600,
        color: isHighlyEngaged ? COLORS.emerald : COLORS.amber,
        background: isHighlyEngaged ? COLORS.emeraldBg : COLORS.amberBg,
        border: `1px solid ${isHighlyEngaged ? 'rgba(16,185,129,0.2)' : 'rgba(245,158,11,0.2)'}`,
        whiteSpace: 'nowrap',
        lineHeight: 1.3,
      }}
    >
      {isHighlyEngaged && (
        <span role="img" aria-label="fire" style={{ fontSize: 12 }}>
          {'\uD83D\uDD25'}
        </span>
      )}
      {tag}
    </span>
  );
};

export default EngagementBadge;
